import React, { useState } from 'react';

import Navbar from './Navbar';
import Footer from './Footer';
const CancellationPolicy = () => {
  const [activeSection, setActiveSection] = useState('returns');

  const containerStyle = {
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: "'Poppins', sans-serif",
    color: '#2d3436',
    backgroundColor: '#ffffff',
    minHeight: '100vh'
  };

  const headerStyle = {
    textAlign: 'center',
    padding: '40px 20px',
    background: 'linear-gradient(135deg, #e17055 0%, #d63031 100%)',
    borderRadius: '12px',
    marginBottom: '30px',
    color: 'white',
    boxShadow: '0 10px 20px rgba(214, 48, 49, 0.3)'
  };

  const titleStyle = {
    fontSize: '2.8rem',
    fontWeight: '700',
    marginBottom: '10px',
    letterSpacing: '0.5px'
  };

  const subtitleStyle = {
    fontSize: '1.2rem',
    fontWeight: '300',
    opacity: '0.9',
    maxWidth: '700px',
    margin: '0 auto'
  };

  const tabContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '30px',
    justifyContent: 'center'
  };

  const tabStyle = {
    padding: '12px 24px',
    borderRadius: '30px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    backgroundColor: '#dfe6e9',
    color: '#636e72'
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: '#e17055',
    color: 'white',
    boxShadow: '0 4px 8px rgba(225, 112, 85, 0.4)'
  };

  const contentStyle = {
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    padding: '30px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.08)'
  };

  const sectionTitleStyle = {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#2d3436',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #e17055'
  };

  const textStyle = {
    fontSize: '1rem',
    lineHeight: '1.7',
    marginBottom: '20px',
    color: '#2d3436'
  };

  const listStyle = {
    paddingLeft: '20px',
    marginBottom: '20px'
  };

  const listItemStyle = {
    marginBottom: '12px',
    position: 'relative',
    paddingLeft: '25px'
  };

  const listIconStyle = {
    position: 'absolute',
    left: '0',
    color: '#e17055',
    fontWeight: 'bold'
  };

  const highlightBoxStyle = {
    backgroundColor: '#ffeaa7',
    borderLeft: '4px solid #fdcb6e',
    borderRadius: '8px',
    padding: '20px',
    margin: '25px 0'
  };

  const warningBoxStyle = {
    backgroundColor: '#ffebee',
    borderLeft: '4px solid #e17055',
    borderRadius: '8px',
    padding: '20px',
    margin: '25px 0'
  };

  const stepContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    margin: '30px 0'
  };

  const stepStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '25px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
  };

  const stepNumberStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#e17055',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 15px',
    fontWeight: 'bold'
  };

  const contactGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    marginTop: '40px'
  };

  const contactCardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '25px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.3s ease',
    cursor: 'pointer'
  };

  const contactIconStyle = {
    fontSize: '2.5rem',
    marginBottom: '15px',
    color: '#e17055'
  };

  const policySections = {
    returns: {
      title: "Returns & Refunds",
      content: (
        <div>
          <p style={textStyle}>
            We want you to be completely satisfied with your purchase. If you're not happy with your order, 
            we offer a straightforward return process.
          </p>
          
          <div style={highlightBoxStyle}>
            <strong>30-Day Return Policy:</strong> You have 30 days from the delivery date to return most items for a full refund or exchange.
          </div>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>Eligibility Conditions:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Items must be unworn, undamaged, and in original packaging</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> All tags and protective films must be intact</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Proof of purchase is required</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Custom prescription eyewear may have different return conditions</li>
          </ul>
          
          <div style={warningBoxStyle}>
            <strong>Non-Returnable Items:</strong> For hygiene reasons, contact lenses cannot be returned once opened. 
            Custom-made eyewear with personalized prescriptions may only be returned if there is a manufacturing defect.
          </div>
        </div>
      )
    },
    cancellation: {
      title: "Order Cancellation",
      content: (
        <div>
          <p style={textStyle}>
            Need to cancel your order? Here's what you need to know:
          </p>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>Before Shipping:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Orders can typically be cancelled within 1 hour of placement</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> For prescription eyewear, cancellation is possible before lens cutting begins</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Full refund will be processed to your original payment method</li>
          </ul>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>After Shipping:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Once shipped, orders cannot be cancelled</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> You can refuse delivery or return the item after receipt</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Standard return policy applies</li>
          </ul>
        </div>
      )
    },
    process: {
      title: "Return Process",
      content: (
        <div>
          <p style={textStyle}>
            Follow these simple steps to return an item:
          </p>
          
          <div style={stepContainerStyle}>
            <div style={stepStyle}>
              <div style={stepNumberStyle}>1</div>
              <h4>Request Return</h4>
              <p>Contact our support team or use the online portal to initiate your return</p>
            </div>
            
            <div style={stepStyle}>
              <div style={stepNumberStyle}>2</div>
              <h4>Pack Securely</h4>
              <p>Place item in original packaging with all accessories and tags</p>
            </div>
            
            <div style={stepStyle}>
              <div style={stepNumberStyle}>3</div>
              <h4>Ship Back</h4>
              <p>Use provided return label and keep tracking information</p>
            </div>
            
            <div style={stepStyle}>
              <div style={stepNumberStyle}>4</div>
              <h4>Receive Refund</h4>
              <p>Refund processed within 5-7 business days after we receive your return</p>
            </div>
          </div>
          
          <div style={highlightBoxStyle}>
            <strong>Free Returns:</strong> We provide prepaid return labels for all eligible returns within the contiguous US.
          </div>
        </div>
      )
    },
    refunds: {
      title: "Refunds",
      content: (
        <div>
          <p style={textStyle}>
            Our refund process is designed to be quick and hassle-free:
          </p>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>Processing Time:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Refunds are processed within 5-7 business days after we receive your return</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Depending on your bank, it may take additional time for the refund to appear in your account</li>
          </ul>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>Refund Methods:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Original payment method (credit card, PayPal, etc.)</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Store credit (if requested, processed immediately)</li>
          </ul>
          
          <div style={warningBoxStyle}>
            <strong>Important:</strong> Shipping charges are non-refundable unless the return is due to our error.
            Customized products may be subject to restocking fees.
          </div>
        </div>
      )
    },
    exchanges: {
      title: "Exchanges",
      content: (
        <div>
          <p style={textStyle}>
            Need a different size, color, or style? We make exchanges easy:
          </p>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>Exchange Options:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Size exchanges for watches and eyewear</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Color or style changes</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Prescription adjustments for eyewear (may incur additional charges)</li>
          </ul>
          
          <h3 style={{...sectionTitleStyle, fontSize: '1.4rem'}}>Exchange Process:</h3>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Initiate exchange through our customer service</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Return the original item following standard return process</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> We'll ship the replacement once we receive your return</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> No additional shipping charges for exchanges (within same value)</li>
          </ul>
        </div>
      )
    }
  };

  return (
    <>
    <Navbar />
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={titleStyle}>Cancellation & Return Policy</h1>
        <p style={subtitleStyle}>
          We strive to make returns and cancellations as simple as possible
        </p>
      </div>

      <div style={tabContainerStyle}>
        {Object.keys(policySections).map((key) => (
          <div 
            key={key}
            style={activeSection === key ? activeTabStyle : tabStyle}
            onClick={() => setActiveSection(key)}
          >
            {policySections[key].title}
          </div>
        ))}
      </div>

      <div style={contentStyle}>
        <h2 style={sectionTitleStyle}>{policySections[activeSection].title}</h2>
        {policySections[activeSection].content}
      </div>

      <div style={contactGridStyle}>
        <div style={contactCardStyle}>
          <div style={contactIconStyle}>📧</div>
          <h3>Email Support</h3>
          <p>suryawanshiwatch1918@gmail.com</p>
          <p>For return requests and questions</p>
        </div>
        
        <div style={contactCardStyle}>
          <div style={contactIconStyle}>📞</div>
          <h3>Call Us</h3>
          <p>+91 79729 64344</p>
          <p>Mon-Fri, 9AM-6PM EST</p>
        </div>
        
        <div style={contactCardStyle}>
          <div style={contactIconStyle}>💬</div>
          <h3>Live Chat</h3>
          <p>Available on our website</p>
          <p>Quick answers to your questions</p>
        </div>
      </div>

    </div>
    <Footer />
    </>
  );
};

export default CancellationPolicy;